// Stores
export const USER_STORE = 'userStore';
export const APP_STORE = 'appStore';
